import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbBuyerPersona from '../components/BreadcrumbBuyerPersona'
import BuyerComponent from '../components/BuyerComponent'
import BuyerPersonaMatter from '../components/BuyerPersonaMatter'
import KeyCapabilities from '../components/KeyCapabilities'
import StrategicAdvantage from '../components/StrategicAdvantage'
import CtaBuyerPersona from '../components/CtaBuyerPersona'

export default function AccountIntelligenceInsights() {
  return (
    <div>
      <Helmet>
        {typeof window !== 'undefined' && (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Account Intelligence & Insights",
        "description":
          "Unlock account-level intelligence with ProPlus Data. Get demographic, firmographic and technographic insights to refine targeting and drive GTM strategy.",
        "provider": {
          "@type": "Organization",
          "name": "ProPlus Data"
        }
      })
    }}
  />
)}


                            <title>Account Intelligence Insights for B2B Growth | ProPlus Data </title>
                            <meta name="description" content="Unlock account-level intelligence with ProPlus Data. Get demographic, firmographic and technographic insights to refine targeting and drive GTM strategy."/>
                            <meta name="keywords" content=" Account Intelligence, B2B Data, Technographic Data, Buyer Intent, Account Insights, Decision-Maker Data, Intent Signals, B2B Lead Generation, Target Accounts, Predictive Analytics, Sales Intelligence, ProPlus Data, Go To Market, Competitor Analysis, 360-degree, Prospect Intelligence"/>
                            <link rel="canonical" href="https://proplusdata.co/account-intelligence-insights"/>
                                                      
                            <meta property="og:url" content="https://proplusdata.co/account-intelligence-insights" />
                            <meta property="og:type" content="website" />
                            <meta property="og:title" content="Account Intelligence Insights for B2B Growth | ProPlus Data " />
                            <meta property="og:description"
                                content="Unlock account-level intelligence with ProPlus Data. Get demographic, firmographic and technographic insights to refine targeting and drive GTM strategy." />
      </Helmet>
      <Header1/>
      <BreadcrumbBuyerPersona/>
      <BuyerComponent/>
      <BuyerPersonaMatter/>
      <KeyCapabilities/>
      <StrategicAdvantage/>
      <CtaBuyerPersona/>
      <Footer/>
      <div class="btnwhatsapp-sm">
        <a target="_blank" rel="noreferrer" href="https://wa.me/+919112110691"><i class="fa fa-whatsapp"></i></a>
    </div>
    </div>
  )
}
